// src/lib/incidents-window.js — PR #153 (ADR-088) · fenêtre portée à 48h
//
// Helper fenêtre de signalement tardif d'incident, ALIGNÉE sur le verrou ménage
// 48h (règle unique « 48h après le ménage, tout se ferme »). Un ménage peut
// signaler un incident sur un run completed jusqu'à INCIDENT_WINDOW_HOURS (48h)
// après son completed_at, même si le run est passé/terminé.
//
// Au-delà : escalade admin (créer un incident manuel via IncidentsTab).
//
// Pure function : pas de side-effect, déterministe sur (run, now).

// Fenêtre unique de signalement, alignée sur le verrou checklist `menage_runs`.
export const INCIDENT_WINDOW_HOURS = 48
const WINDOW_MS = INCIDENT_WINDOW_HOURS * 3600 * 1000

/**
 * Vérifie si l'instant `now` est encore dans la fenêtre INCIDENT_WINDOW_HOURS
 * après `run.completed_at`.
 *
 * @param {Object|null} run - Run DB. Doit avoir `completed_at` (ISO timestamp)
 * @param {Date} [now] - Instant courant (défaut : new Date())
 * @returns {boolean} true si fenêtre encore ouverte (strict <), false sinon
 *
 * Cas edge :
 *   - run null/undefined → false
 *   - run.completed_at null/undefined → false (pas de fenêtre sans completed)
 *   - completed_at invalide (parse NaN) → false (sécurité)
 *   - now < completed_at (futur impossible) → true (delta négatif < fenêtre)
 *
 * Comparaison stricte `<` : à l'instant pile INCIDENT_WINDOW_HOURS, fenêtre fermée.
 */
export function isWithinIncidentWindow(run, now = new Date()) {
  if (!run || !run.completed_at) return false
  const completedTs = new Date(run.completed_at).getTime()
  if (Number.isNaN(completedTs)) return false
  const nowTs = (now instanceof Date ? now : new Date(now)).getTime()
  if (Number.isNaN(nowTs)) return false
  const delta = nowTs - completedTs
  return delta < WINDOW_MS  // strict <
}

/**
 * Calcule le nombre d'heures restantes dans la fenêtre INCIDENT_WINDOW_HOURS.
 * Retourne 0 si fenêtre fermée ou run invalide.
 *
 * @param {Object|null} run
 * @param {Date} [now]
 * @returns {number} heures restantes (entier, floor), 0 si hors fenêtre
 */
export function hoursRemainingInIncidentWindow(run, now = new Date()) {
  if (!isWithinIncidentWindow(run, now)) return 0
  const completedTs = new Date(run.completed_at).getTime()
  const nowTs = (now instanceof Date ? now : new Date(now)).getTime()
  const remainingMs = WINDOW_MS - (nowTs - completedTs)
  return Math.max(0, Math.floor(remainingMs / (3600 * 1000)))
}
